import request from '@utils/request'
import { ReturnType } from './types'

const getAll = async (params: any) => {
  try {
    const config: ReturnType = {
      url: 'drivers',
      method: 'get',
      params,
      authorization: true,
      config: {
        showErr: true,
        store: {
          action: 'set',
          key: 'drivers',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}

const create = async (data: any) => {
  try {
    const config: ReturnType = {
      url: 'drivers',
      method: 'post',
      data,
      authorization: true,
      config: {
        showErr: true,
        successMsg: 'Driver created successfully!',
        store: {
          action: 'prepend',
          key: 'drivers',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}
const update = async (data: any, id: number) => {
  try {
    const config: ReturnType = {
      url: `drivers/${id}`,
      method: 'patch',
      data,
      authorization: true,
      config: {
        showErr: true,
        successMsg: 'Driver created successfully!',
        store: {
          action: 'update',
          key: 'drivers',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}
const updateStatus = async (data: any, id: number) => {
  try {
    const config: ReturnType = {
      url: `drivers/update-status/${id}`,
      method: 'patch',
      data,
      authorization: true,
      config: {
        showErr: true,
        successMsg: 'Driver Status updated successfully!',
        store: {
          action: 'update',
          key: 'drivers',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}
const remove = async (id: any) => {
  try {
    const config: ReturnType = {
      url: `drivers/${id}`,
      method: 'delete',
      authorization: true,

      config: {
        showErr: true,
        successMsg: 'Driver deleted successfully!',
        store: {
          action: 'remove',
          key: 'drivers',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}

export default {
  remove,
  update,
  create,
  getAll,
  updateStatus,
}
